module.exports = __webpack_public_path__ + "static/media/wallpaper-art-image.d8c03e7f.jpg";